module.exports = __webpack_public_path__ + "static/img/x1.b801b42b.png";